var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUPenn(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "basic",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "144px",
    height: "161.214px",
    viewBox: "0 0 144 161.214",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M0.015,0H144c0,0,0,70.733,0,71.981c-0.974,58.674-66.725,89.515-74.996,89.23 C60.401,160.917-0.18,130.741,0,71.677C0.004,70.613,0.015,0,0.015,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.4715,
    strokeMiterlimit: 3.8636,
    d: "M137.343,3.212"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M3.487,3.827h137.131c0,0,0,67.366,0,68.554c-0.93,55.881-63.551,85.25-71.429,84.981 c-8.19-0.28-65.889-29.02-65.715-85.273C3.476,71.079,3.487,3.827,3.487,3.827z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A90533",
    stroke: "#A90533",
    strokeWidth: 0.5045,
    strokeMiterlimit: 3.8636,
    d: "M3.474,45.489 C3.673,45.687,3.482,3.838,3.482,3.838h137.031c0,0,0,22.444,0,41.652L3.474,45.489z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#004684",
    stroke: "#004684",
    strokeWidth: 0.5042,
    strokeMiterlimit: 3.8636,
    d: "M11.153,106.466 c5.27,11.079,11.787,20,20.935,27.59l39.902-40.343l38.406,39.395c7.918-7.239,15.629-16.006,21.155-26.391L71.941,49.37 l-60.516,57.214L11.153,106.466z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.4715,
    strokeMiterlimit: 3.8636,
    d: "M36.535,2.689"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.4715,
    strokeMiterlimit: 3.8636,
    d: "M32.356,3.123"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.4715,
    strokeMiterlimit: 3.8636,
    d: "M6.062,3.123"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.4715,
    strokeMiterlimit: 3.8636,
    d: "M15.121,3.479"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.4715,
    strokeMiterlimit: 3.8636,
    d: "M24.016,3.123"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.4715,
    strokeMiterlimit: 3.8636,
    d: "M111.266,3.123"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.4715,
    strokeMiterlimit: 3.8636,
    d: "M119.814,3.837"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.4715,
    strokeMiterlimit: 3.8636,
    d: "M128.503,3.659"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.4715,
    strokeMiterlimit: 3.8636,
    d: "M28.512,2.765"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.4715,
    strokeMiterlimit: 3.8636,
    d: "M19.613,3.123"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.4715,
    strokeMiterlimit: 3.8636,
    d: "M10.555,2.765"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.4715,
    strokeMiterlimit: 3.8636,
    d: "M72.019,35.793"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.4715,
    strokeMiterlimit: 3.8636,
    d: "M54.829,39.008"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.4715,
    strokeMiterlimit: 3.8636,
    d: "M46.072,41.15"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.4715,
    strokeMiterlimit: 3.8636,
    d: "M81.286,40.436"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.4715,
    strokeMiterlimit: 3.8636,
    d: "M132.999,3.302"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.4715,
    strokeMiterlimit: 3.8636,
    d: "M115.762,2.765"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.4715,
    strokeMiterlimit: 3.8636,
    d: "M89.44,41.685"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.4715,
    strokeMiterlimit: 3.8636,
    d: "M124.31,3.479"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.4715,
    strokeMiterlimit: 3.8636,
    d: "M106.866,2.765"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#004684",
    strokeWidth: 0.5045,
    strokeMiterlimit: 3.8636,
    x1: 3.474,
    y1: 45.772,
    x2: 140.504,
    y2: 45.754
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.4715,
    strokeMiterlimit: 3.8636,
    d: "M67.628,33.551"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.4715,
    strokeMiterlimit: 3.8636,
    d: "M50.335,41.507"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.4715,
    strokeMiterlimit: 3.8636,
    d: "M58.814,34.902"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.4715,
    strokeMiterlimit: 3.8636,
    d: "M41.103,3.123"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.4715,
    strokeMiterlimit: 3.8636,
    d: "M93.335,24.368"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.4715,
    strokeMiterlimit: 3.8636,
    d: "M84.948,41.328"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.4715,
    strokeMiterlimit: 3.8636,
    d: "M63.44,32.791"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.4715,
    strokeMiterlimit: 3.8636,
    d: "M81.576,23.297"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.4715,
    strokeMiterlimit: 3.8636,
    d: "M97.886,39.186"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.4715,
    strokeMiterlimit: 3.8636,
    d: "M89.617,28.832"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.4715,
    strokeMiterlimit: 3.8636,
    d: "M76.897,38.115"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.4715,
    strokeMiterlimit: 3.8636,
    d: "M93.304,41.238"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.4715,
    strokeMiterlimit: 3.8636,
    d: "M85.573,32.147"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.2522,
    strokeMiterlimit: 3.8636,
    d: "M29,131.396"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#004684",
    strokeWidth: 0.5045,
    strokeMiterlimit: 3.8636,
    d: "M106.178,14.188h3.73 c2.733-0.624,3.729-2.209,6.531-2.209c2.018,0,2.969,1.34,4.45,1.34c1.252,0,3.173-1.428,5.282-1.428 c2.154,0,3.22,1.294,4.635,1.896c1.252,0.536,2.895,0.507,4.634,0.507c-0.048,1.25,0,1.993,0,3.041 c0,1.071,1.435,0.647,1.435,2.389c0,1.83-1.855,1.473-1.855,2.209l-0.066,6.806c0.093,0.848,1.808,0.96,1.808,2.253 c0,1.919-1.91,1.255-1.785,2.768c0.092,1.115,0,3.481,0,3.481c-3.685,0-27.376,0.216-28.534,0.172 c0.07-2.522,0.462-2.372,0.548-3.587c0.07-0.982-2.13-1.584-2.13-3.236c0-1.139,1.318-1.071,1.435-2.143v-6.784 c-0.069-0.893-2.062-1.339-1.993-2.61c0.083-1.522,1.854-1.328,1.854-2.344C106.154,16.265,106.202,14.613,106.178,14.188z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#004684",
    strokeWidth: 0.5045,
    strokeMiterlimit: 3.8636,
    d: "M109.213,14.301 c0,0,0.047,15.175,0,18.746c0,0,22.103,0.044,23.074-0.045c0-4.04-0.022-18.813-0.022-18.813"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#004684",
    strokeWidth: 0.5045,
    strokeMiterlimit: 3.8636,
    x1: 120.773,
    y1: 13.363,
    x2: 120.773,
    y2: 33.091
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#004684",
    stroke: "#004684",
    strokeWidth: 0.5045,
    strokeMiterlimit: 3.8636,
    d: "M121.124,30.659 c0.972,0.044,2.758,0.701,4.493,1.227c2.246,0.68,4.63,0.204,6.394,0.558c0.557,0.112-10.887,0.201-10.887,0.201 C121.168,30.435,121.124,30.659,121.124,30.659z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#004684",
    stroke: "#004684",
    strokeWidth: 0.5045,
    strokeMiterlimit: 3.8636,
    cx: 120.762,
    cy: 33.583,
    rx: 1.287,
    ry: 0.894
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#004684",
    stroke: "#004684",
    strokeWidth: 0.5045,
    strokeMiterlimit: 3.8636,
    d: "M120.762,33.583"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#004684",
    stroke: "#004684",
    strokeWidth: 0.5045,
    strokeMiterlimit: 3.8636,
    d: "M120.132,30.659 c-0.974,0.044-2.759,0.701-4.496,1.227c-2.246,0.68-4.628,0.204-6.391,0.558c-0.558,0.112,10.887,0.201,10.887,0.201 C120.085,30.435,120.132,30.659,120.132,30.659z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#004684",
    strokeWidth: 0.5042,
    strokeMiterlimit: 3.8636,
    d: "M44.197,39.227 c0.369,1.45,1.458,2.41,3.242,2.41c3.313,0,6.511-2.456,8.434-3.838c1.505-1.071,3.058-2.209,3.058-4.553l-0.277,0.893 c0,0,2.595-2.588,8.987-0.536c1.778,0.571,9.385,4.842,11.029,5.535c1.414,0.603,6.367,4.156,14.108,2.786 c0,0,11.819-1.626,9.179-13.798c-1.886-8.7-1.302-9.318-0.582-12.107c-0.277-0.134-7.229-1.696-7.044,7.944 c-3.014,0.313-6.858,2.588-4.355,8.57c1.02-1.518,2.386-3.125,4.263-3.125c1.181,0,2.427,1.697,2.502,2.946 c0.187,3.035-2.872,4.374-6.671,3.749c-1.927-0.316-3.701-2.451-6.356-4.372c0.465-0.223,0.887-1.787,0.887-2.412 c0-1.54-1.32-2.253-2.222-2.768c0.185-0.535,0.554-1.25,0.554-1.785c0-1.227-1.737-1.138-2.409-1.606 c0.277-0.38,0.277-0.156,0.277-0.715c0-1.786,0.28-2.768-3.334-2.677c0.301-1.764-0.07-2.901-1.299-3.393l-2.688-0.356 c-1.667-0.312-0.003-0.868-1.543-2.351c-1.374-1.325-3.635,0-3.635,0c0-1.228-0.845-2.202-2.327-2.202 c-0.789,0-1.761,0.067-2.315,0.358l-1.114,0.893c-1.391,0-1.737-1.25-3.336-1.25s-2.248,1.25-2.873,2.054 c-1.09-0.514-1.228-1.428-2.687-1.428c-0.857,0-1.112,0.915-1.482,1.338c-0.952,1.049-0.883,2.136-2.366,2.672l-0.551-0.97 c-0.019-0.061-0.033-0.123-0.048-0.185c-2.18,1.049-7.092,12.251-7.092,14.549c0,2.188,1.901,1.229,1.901,3.573 c0,1.383-2.038,2.388-2.038,3.57c0,1.495,1.737,2.231,3.242,2.231L44.197,39.227z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#004684",
    stroke: "#004684",
    strokeWidth: 0.5045,
    strokeMiterlimit: 3.8636,
    d: "M49.315,29.815 c0,0,2.41,0.927,2.41,1.428c0,0.678-1.558,1.427-2.594,2.32h-1.298c0.465-1.518,0-0.964,0-2.32 C47.833,30.226,48.908,29.815,49.315,29.815z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#004684",
    strokeWidth: 0.5045,
    strokeMiterlimit: 3.8636,
    d: "M58.119,25.707 c1.252-0.602,0.671-2.142,2.688-2.142c1.783,0,2.456,1.249,4.077,1.249c1.089,0,1.853-1.071,3.335-1.071 c1.32,0,3.058,1.786,2.781,3.928c0,0,4.632-1.518,4.447,3.481c3.706-1.25,3.338,1.808,3.706,3.302 c0.373,1.429,2.781,0.269,2.41,3.303"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#004684",
    strokeWidth: 0.5045,
    strokeMiterlimit: 3.8636,
    d: "M8.66,14.31h3.73 c2.734-0.625,3.73-2.21,6.533-2.21c2.017,0,2.965,1.339,4.447,1.339c1.25,0,3.176-1.428,5.283-1.428 c2.156,0,3.221,1.294,4.634,1.896c1.25,0.536,2.895,0.508,4.634,0.508c-0.046,1.249,0,1.991,0,3.041 c0,1.071,1.437,0.647,1.437,2.387c0,1.83-1.855,1.473-1.855,2.209l-0.068,6.808c0.092,0.847,1.807,0.958,1.807,2.253 c0,1.92-1.908,1.255-1.783,2.767c0.092,1.117,0,3.481,0,3.481c-3.685,0-26.876,0.023-28.034-0.022 c0.07-2.522-0.039-2.177,0.046-3.392c0.07-0.982-2.131-1.584-2.131-3.236c0-1.138,1.32-1.071,1.437-2.142v-6.785 c-0.068-0.892-2.062-1.338-1.994-2.611c0.085-1.521,1.855-1.326,1.855-2.343C8.638,16.385,8.684,14.733,8.66,14.31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#004684",
    strokeWidth: 0.5045,
    strokeMiterlimit: 3.8636,
    d: "M11.695,14.421c0,0,0.046,15.175,0,18.746 c0,0,22.102,0.044,23.076-0.045c0-4.039-0.024-18.812-0.024-18.812"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#004684",
    strokeWidth: 0.5045,
    strokeMiterlimit: 3.8636,
    x1: 23.256,
    y1: 13.483,
    x2: 23.256,
    y2: 33.211
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#004684",
    stroke: "#004684",
    strokeWidth: 0.5045,
    strokeMiterlimit: 3.8636,
    d: "M23.603,30.779 c0.974,0.045,2.761,0.702,4.496,1.227c2.246,0.682,4.628,0.204,6.393,0.558c0.557,0.111-10.889,0.201-10.889,0.201 C23.649,30.556,23.603,30.779,23.603,30.779z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#004684",
    stroke: "#004684",
    strokeWidth: 0.5045,
    strokeMiterlimit: 3.8636,
    cx: 23.244,
    cy: 33.703,
    rx: 1.285,
    ry: 0.894
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#004684",
    stroke: "#004684",
    strokeWidth: 0.5045,
    strokeMiterlimit: 3.8636,
    d: "M23.246,33.703"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#004684",
    stroke: "#004684",
    strokeWidth: 0.5045,
    strokeMiterlimit: 3.8636,
    d: "M22.615,30.779 c-0.974,0.045-2.76,0.702-4.496,1.227c-2.246,0.682-4.628,0.204-6.395,0.558c-0.555,0.111,10.891,0.201,10.891,0.201 C22.567,30.556,22.615,30.779,22.615,30.779z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#004684",
    strokeWidth: 0.5045,
    strokeMiterlimit: 3.8636,
    d: "M27.033,101.9 c0-6.365,5.357-11.528,11.964-11.528c6.609,0,11.966,5.163,11.966,11.528c0,6.366-5.357,11.521-11.966,11.521 C32.39,113.421,27.033,108.266,27.033,101.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#004684",
    strokeWidth: 0.5045,
    strokeMiterlimit: 3.8636,
    d: "M38.997,101.9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFFFFF",
    stroke: "#004684",
    strokeWidth: 0.5042,
    strokeMiterlimit: 3.8636,
    cx: 71.89,
    cy: 74.216,
    rx: 11.964,
    ry: 11.525
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#004684",
    strokeWidth: 0.5042,
    strokeMiterlimit: 3.8636,
    d: "M71.89,74.216"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#004684",
    strokeWidth: 0.5045,
    strokeMiterlimit: 3.8636,
    d: "M90.96,101.9 c0-6.365,5.356-11.528,11.966-11.528c6.606,0,11.963,5.163,11.963,11.528c0,6.366-5.356,11.521-11.963,11.521 C96.316,113.421,90.96,108.266,90.96,101.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#004684",
    strokeWidth: 0.5045,
    strokeMiterlimit: 3.8636,
    d: "M102.926,101.9"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#004684",
    strokeWidth: 0.5045,
    strokeMiterlimit: 3.8636,
    d: "M83.89,31.256 c-3.057-3.365-5.753-7.316-6.218-7.513c-1.505-0.625-5.097-7.766-14.733-8.302c-2.449-0.136-11.665,0.759-11.982,3.117"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#004684",
    strokeWidth: 0.5045,
    strokeMiterlimit: 3.8636,
    d: "M58.991,33.852 c0.035-0.231,0.056-0.477,0.056-0.736c0-0.383-2.259-0.166-2.796-0.326c-0.371-0.111,0.994-0.656,0.756-0.656 c1.39-0.536,4.951-2.103,3.708-3.303c-1.206-1.161-1.925-2.388-2.596-3.125c-0.903-0.982-1.969-1.518-3.614-1.518 c-1.413,0-3.703,2.452-4.654,3.122c0.697-0.67,2.707-2.408,2.707-3.836c0-3.213-2.57-6.003-3.242-8.659"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#004684",
    strokeWidth: 0.5045,
    strokeMiterlimit: 3.8636,
    d: "M45.137,38.739 c2.546,0,3.983-0.178,5.189-0.803c1.32-0.691,3.706-2.187,4.263-3.481"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#004684",
    strokeMiterlimit: 3.8636,
    d: "M3.443,3.838h137.129c0,0,0,67.366,0,68.554 c-0.928,55.88-63.549,85.25-71.427,84.98c-8.191-0.28-65.889-29.02-65.715-85.271C3.432,71.09,3.443,3.838,3.443,3.838z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUPenn);
export default __webpack_public_path__ + "static/media/UPenn.3833c0607c1973d60ddc3da3b8e4626f.svg";
export { ForwardRef as ReactComponent };